import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as Quill  from 'quill';
import { EditorFormat } from '../../editor-format.service';
import { SocketsService } from 'src/app/_provider/sockets.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { HttpService } from 'src/app/_provider/http.service';
import { TextmodulesService, TextSnippet } from 'src/app/_provider/textmodules/textmodules.service';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { ImageResizeFixed } from '../../content-edit-popup.page';
import ImageCompress from 'quill-image-compress';


@Component({
  selector: 'app-content-text-module-edit',
  templateUrl: './content-text-module-edit.page.html',
  styleUrls: ['./content-text-module-edit.page.scss', '../../editor-toolbar.scss'],
})
export class ContentTextModuleEditPage extends EditorFormat implements OnInit {

  public editor: Quill
  public title: string = "Neuer Textbaustein"
  public isNew: boolean = true

  public snippet: TextSnippet = {
    title: "",
    content: ""
  }

  constructor(
    private modalCtrl: ModalController,
    public textModulesSrv: TextmodulesService,
    public socketSrv: SocketsService,
    public generalSrv: GeneralService,
    public feedback: FeedbackService,
    public http: HttpService
  ) { 
    super(feedback, http, socketSrv)
  }

  ngOnInit() {

    Quill.register('modules/imageResize', ImageResizeFixed, true);
    Quill.register('modules/ImageCompress', ImageCompress, true);

    this.editor = new Quill(`#moduleEditor`, {
      modules: {
        toolbar: '#module-toolbar-container',
        "imageResize": {
          displayStyles: {
            backgroundColor: 'black',
            border: 'none',
          }},
          "ImageCompress": {
            quality: 0.8,
            maxWidth: 900, 
            maxHeight: 900,
          },
      },
      theme: 'snow',
      
    })

    this.formatEditor = this.editor
    
    if(this.snippet.content) {
      setTimeout(() => {
        const removedBody: string = this.snippet.content.replace("<body>", "").replace("</body>", "").replace("\t", "")
        var delta = this.editor.clipboard.convert(removedBody)
        this.editor?.setContents(delta, "silent")
      }, 0);
    }
  }

  public async close(){
    await this.modalCtrl.dismiss()
  }

  public async save(){

    if(!this.snippet.title) return await this.feedback.showError("Bitte geben Sie einen Titel für das Textbaustein an.")
    this.snippet.content = `<body>${this.editor.root.innerHTML}</body>`

    await this.feedback.showLoading(async ()=>{

      let result: HttpFunctionResult<TextSnippet>
      if(this.isNew) result = await this.textModulesSrv.addSnippet(this.snippet)
      else result = await this.textModulesSrv.updateSnippet(this.snippet)

      if(!result.success) return
      await this.modalCtrl.dismiss(result.data)
    }, "Speichern...")

    
  }

}
